import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';


@Injectable()
export class PageNotFoundGuard implements CanActivate {
  constructor(
    private router: Router,
  ) { }

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    this.router.navigate(['/page-not-found']);
    return false;
  }
}
